import React from 'react';

interface Props {
  fillColor: string;
}

const StoolLittleHard = ({ fillColor }: Props) => {
  return (
    <svg width='27' height='19' viewBox='0 0 27 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.78235 7.58804C1.37499 9.07303 -0.200415 11.131 0.0206292 14.1437C0.33917 18.4851 6.90175 18.3855 8.95472 18.3855C12.834 18.3855 22.7083 15.0434 25.8825 10.416C27.6729 7.80569 26.9404 4.76012 26.2351 2.96054C25.4928 1.06657 24.1203 0.108059 22.2383 0.00408692C20.2017 -0.10842 19.0766 2.13244 17.1833 2.96054C13.6567 4.50303 8.36675 4.76012 3.78235 7.58804Z'
        fill={fillColor}
      />
    </svg>
  );
};

export default StoolLittleHard;
